<template>
    <div class="DialogBulkPlannedSchedule">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ title }}</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <b-field label="בחר קורס">
                    <b-select v-model="selectedCourseId" :loading="coursesLoading" expanded>
                        <option :value="null" disabled>בחר קורס</option>
                        <option v-for="course in courses" :key="course.id" :value="course.id">{{ course.name }}</option>
                    </b-select>
                </b-field>
                <b-field label="הדבק רשימת מזהי משתמשים (מופרדים בפסיק או שורה חדשה, עד 200)">
                    <b-input type="textarea" v-model="text" rows="8" placeholder="232, 343, 3422"></b-input>
                </b-field>
                <div class="counter">מזהים שזוהו: <strong>{{ ids.length }}</strong></div>
            </section>
            <footer class="modal-card-foot">
                <b-button :loading="isLoading" type="is-primary" label="הורד" @click="submit" />
                <b-button :disabled="isLoading" label="ביטול" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
import { ToastProgrammatic as Toast } from "buefy";
import AdminService from "@/services/AdminService";
import CoursesService from "@/services/CoursesService";

export default {
    name: "DialogBulkPlannedSchedule",
    props: {
        kind: { type: String, required: true },
        defaultCourseId: { type: [Number, String], default: null }
    },
    data() {
        return {
            text: "",
            isLoading: false,
            courses: [],
            coursesLoading: false,
            selectedCourseId: this.defaultCourseId
        };
    },
    created() {
        this.loadCourses();
    },
    computed: {
        title() {
            return this.kind === 'sent'
                ? 'הורד JSON שנשלח עבור רשימת משתמשים'
                : 'הורד JSON שהתקבל עבור רשימת משתמשים';
        },
        ids() {
            return [...new Set(
                this.text.split(/[,\s]+/)
                    .map(Number)
                    .filter(n => Number.isInteger(n) && n > 0)
            )];
        }
    },
    methods: {
        loadCourses() {
            this.coursesLoading = true;
            CoursesService.getCourses(true)
                .then((r) => { this.courses = r.data || []; })
                .catch(() => {
                    Toast.open({ type: 'is-danger', message: 'שגיאה בטעינת רשימת הקורסים', duration: 4000 });
                })
                .finally(() => { this.coursesLoading = false; });
        },
        parseFilename(headers) {
            const cd = headers && (headers['content-disposition'] || headers['Content-Disposition']);
            if (cd) {
                const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
                if (match && match[1]) return decodeURIComponent(match[1]);
            }
            return `${this.kind}_JSONs_course_${this.selectedCourseId}.zip`;
        },
        saveBlob(blob, filename) {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        },
        async submit() {
            if (!this.selectedCourseId) {
                Toast.open({ type: 'is-warning', message: 'יש לבחור קורס', duration: 4000 });
                return;
            }
            const ids = this.ids;
            if (ids.length === 0) {
                Toast.open({ type: 'is-warning', message: 'חובה להזין לפחות מזהה משתמש אחד', duration: 4000 });
                return;
            }
            if (ids.length > 200) {
                Toast.open({ type: 'is-warning', message: `ניתן להוריד עד 200 משתמשים בבת אחת (הוזנו ${ids.length})`, duration: 5000 });
                return;
            }
            this.isLoading = true;
            try {
                const response = await AdminService.downloadBulkPlannedSchedule(this.selectedCourseId, this.kind, ids);
                const filename = this.parseFilename(response.headers);
                this.saveBlob(response.data, filename);
                this.$emit('close');
            } catch (err) {
                const status = err && err.response && err.response.status;
                if (status === 403) {
                    Toast.open({ type: 'is-danger', message: 'אין הרשאת מנהל', duration: 5000 });
                } else if (status === 400 && err.response.data) {
                    let message = 'שגיאה בהורדת הקובץ';
                    try {
                        message = await err.response.data.text();
                    } catch (e) { /* leave fallback */ }
                    Toast.open({ type: 'is-danger', message, duration: 6000 });
                } else {
                    Toast.open({ type: 'is-danger', message: 'שגיאה בהורדת הקובץ', duration: 5000 });
                }
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.counter {
    margin-top: 8px;
    color: #555;
}
</style>
